import { Gender } from '@trialcard/enums';

export default [
    { id: Gender.M, name: 'Male', code: Gender[Gender.M] },
    { id: Gender.F, name: 'Female', code: Gender[Gender.F] },
    { id: Gender.I, name: 'Other', code: Gender[Gender.I] },
] as IGenderObject[];

export interface IGenderObject {
    id: Gender;
    name: string;
    code: string;
}
